<app-loader *ngIf="addServiceFunctionLoading"></app-loader>
<div class="modal__header">
  <span class="title">Создание служебной функции</span>
  <div class="modal-close color-gray-dark" id="appServiceFunctionCloseX" (click)="activeModal.dismiss()"></div>
</div>
<div class="modal__body">
  <form [formGroup]="addServiceFunctionForm" (ngSubmit)="onSubmitAddNewServiceFunctionForm()">
    <div class="grid">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s title--vertical title--required">Название</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <app-field>
          <input class="input-text" type="text" id="serviceFunctionName" formControlName="service_function_name" maxlength="100" />
        </app-field>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s title--vertical title--required">Описание</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <app-field>
          <textarea class="input-textarea" cols="" rows="5" id="desctiprion" formControlName="description" maxlength="1000"></textarea>
        </app-field>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Отображение в системе</div>
      </div>
      <div class="grid__box grid__box--size-9">Включено</div>
    </div>
    <div class="delimiter delimiter--gray-bright delimiter--size-1 mt-24 mb-24"></div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Дата создания</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Дата изменения</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Создал</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Изменил</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Версия</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div class="mdash"></div>
      </div>
    </div>
    <div class="mt-16" *ngIf="needRequiredFieldError">
      <app-message [type]="'error'">
        <div message-content>
          Не заполнены или заполнены с ошибками поля:<br />
          <span class="mdash"></span> Название<br />
          <span class="mdash"></span> Описание
        </div>
      </app-message>
    </div>
    <div class="mt-16" *ngIf="backendError">
      <app-message [type]="'error'">
        <div message-content>Не удалось сохранить запись. Повторите попытку через некоторое время. При повторении ошибки свяжитесь с техподдержкой системы.</div>
      </app-message>
    </div>
  </form>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" id="appServiceFunctionSubmit" (click)="onSubmitAddNewServiceFunctionForm()">Сохранить</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" id="appServiceFunctionClose" (click)="activeModal.dismiss()"> Отмена </a>
  </div>
</div>
